import { DefaultRequest } from 'scripts/api';

/* Model */
class SMSConfigurationModel extends App.Models.BaseModel {
    modelUrl = 'SMSConfiguration';
}

App.Models.SMSConfiguration = SMSConfigurationModel;

/* Collection */
class SMSConfigurationCollection extends App.Collections.BaseCollection {
    url = 'SMSConfiguration';
    model = App.Models.SMSConfiguration;
}

App.Collections.SMSConfigurations = SMSConfigurationCollection;

/* Router */
class SMSConfigurationRouter extends App.Routers.BaseRouter {
    constructor() {
        const entityName = 'SMSConfiguration';
        const model = App.Models.SMSConfiguration;
        const collectionClass = App.Collections.SMSConfigurations;

        super(entityName, model, collectionClass);
    }

    test = () => {
        this.obj = {};

        this.showModal = function (scope) {
            var selector = "#SMSConfiguration";
            var scopeBlock = "#SMSConfiguration .form_and_grid_generic";
            var options = {
                width: 400,
                height: 250
            };
            var callbacks = {
                onAfterShowModalForm: scope.createAllStructure,
                addListener: scope.addListener,
                scope: scope
            };

            var modal = new Monet.Form.Modal(selector, options, callbacks, scopeBlock);
            modal.showModalForm();
        };

        this.addListener = function (button) {
            var replaceAll = function (string) {
                var newValue = '';
                for (var i = 0; i < string.length; i++) {
                    newValue += string[i];
                }
                return newValue;
            };

            var numberSms = document.querySelector('#SMSConfiguration #smsSent input[type="text"]');
            var valor = numberSms.value.match(/[0-9]/g) || '';
            numberSms = replaceAll(valor);

            if (numberSms !== '') {
                var div = document.querySelector('#smsSent .testAlert');
                var label = Monet.I18n.getResourcesByKey('smsConfiguration.accountBalance');

                var obj = {};
                obj.accountSid = App.Forms.SMSConfiguration.credentialsSms.accountSid;
                obj.authToken = App.Forms.SMSConfiguration.credentialsSms.authToken;
                obj.fromNumber = App.Forms.SMSConfiguration.credentialsSms.fromNumber;
                button.toggleLoadingInBtn();
                const request = new DefaultRequest({
                    url: 'SMSConfiguration/SendTestSms?toNumber=' + numberSms,
                    method: 'post',
                    data: obj,
                    beforeSend: function () {
                        div.innerHTML = "";
                    },
                    success: function () {
                        const request = new DefaultRequest({
                            url: 'SMSConfiguration/AccountBalance',
                            type: 'GET',
                            success: function (data) {
                                div.innerHTML = label + ': ' + data;
                            }
                        });
                        request.send();
                    },
                    error: function (xhr) {
                        var e = JSON.parse(xhr.responseText);
                        button.toggleLoadingInBtn();
                        div.innerHTML = '<i class="fa fa-times-circle"></i> ' + e.errorMessages[0].resource.i18nMessage;
                    }
                });
                request.send();
            }
        };

        this.createAllStructure = function () {

            var textInput = new Monet.UI.Fields.TextField();
            var buttonInput = new Monet.UI.Fields.Button();

            var div = document.querySelector('.popupFormContainer');
            var labelText = Monet.I18n.getResourcesByKey('smsConfiguration.statusSms');
            var labelButton = Monet.I18n.getResourcesByKey('smsConfiguration.btnStatusSms');
            var alertDiv = document.createElement('div');
            alertDiv.className = 'testAlert';

            var validateInput = '',
                phone         = '',
                hasNonNumeric = '';

            textInput.setTextLabel(labelText);
            textInput.setInputName('smsInputText');
            textInput.setId('smsSent');

            buttonInput.setId('btnSms');
            buttonInput.setValue(labelButton);
            buttonInput.addEventListener('click', () => {
                this.addListener(buttonInput);
            });
            buttonInput.disable();

            div.appendChild(textInput.render());
            div.children[0].appendChild(buttonInput.render());
            div.children[0].appendChild(alertDiv);


            $('#SMSConfiguration #smsSent input[type="text"]').on("keyup", function (e) {
                validateInput = $(e.target).val();
                validateInput.length > 0 ? buttonInput.enable() : buttonInput.disable();
                phone = validateInput.match(/[^0-9.]/g);
                hasNonNumeric = ( validateInput.match(/[^0-9.]/g) !== null ) ? true : false;

                if (hasNonNumeric) {
                    for (var i = 0; i < phone.length; i++) {
                        var x = $(e.target).val().replace(phone[i], "");
                        $(e.target).val(x);
                    }
                }
            });

        };

        var isEmpty = function (values) {
            return !(values && values.organization
            && values.organization.id !== ''
            && values.accountSid
            && values.accountSid !== ''
            && values.fromNumber
            && values.fromNumber !== ''
            && values.authToken
            && values.authToken !== '');
        };

        var values = App.Forms.SMSConfiguration.form.getValues();

        if (isEmpty(values)) {
            new Greenmile.Components.AlertModal('please.enter.your.information')
                .show();
        } else {
            App.Forms.SMSConfiguration.credentialsSms = values;
            this.showModal(this);
        }
    }
}

App.Routers.SMSConfiguration = SMSConfigurationRouter;
